var icon = require('vue-svgicon')
icon.register({
  'ks-icon-calendar': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M93.56 97.78H34.44V51.33h59.12M80.89 21.78v8.44H47.11v-8.44h-8.44v8.44h-4.23A8.42 8.42 0 0 0 26 38.67v59.11a8.44 8.44 0 0 0 8.44 8.44h59.12a8.44 8.44 0 0 0 8.44-8.44V38.67a8.44 8.44 0 0 0-8.44-8.44h-4.23v-8.45m-4.22 46.44H64v21.11h21.11z"/>'
  }
})
